export const DOMAIN_SETUP_ARTICLE_URL = 'https://help.feathr.co/hc/en-us/articles/360040220793';
